import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/@shared';
import { QaAutomationV1RoutingModule } from './qaautomation.v1.routing.module';

@NgModule({
  declarations: [
  ],
  imports: [
    SharedModule,
    QaAutomationV1RoutingModule
  ]
})

export class QaAutomationV1Module { }
